
<template>
  <div class="flex-wrapper-vertical">
      <section class="searchTable" v-if="assets">
        <h3>Die Bibliothek beinhalted {{assets.length}} Pfade</h3>
        <table>
          <tr v-for="record in assets" :key="record.id">
            <td>{{ record.name }}</td>
            <td>{{ record.steps }} Lernschritte</td>
            <td>
              <font-awesome-icon
                :icon="['fas', 'folder-open']"
                class="mr-2"
                @click="selectGraph(record)"
              />
            </td>
          </tr>
        </table>
      </section>
      <section class="flex-wrapper-vertical">
        <section class="flex-wrapper">
          <button
            class="bx--btn bx--btn--primary mv-2 mr-2 flex"
            type="button"
            disabled
          >
            <font-awesome-icon :icon="['fas', 'plus-circle']" class="mr-2" />Hinzufügen
          </button>
          <button
            class="bx--btn bx--btn--primary mv-2 mr-2 flex"
            type="button"
            disabled
          >
            <font-awesome-icon :icon="['fas', 'edit']" class="mr-2" />Bearbeiten
          </button>
        </section>
        <section class="flex"/>
        <section class="flex-wrapper right-aligned">
          <button
            class="bx--btn bx--btn--primary mv-2 mr-2"
            type="button"
            @click.prevent="selectUserGraph()"
          >
            <font-awesome-icon :icon="['fas', 'undo']" class="mr-2" />Zum aktuellen Pfad
          </button>
        </section>
      </section>
      <!-- <ul class="ml-5">
        <li class="ma-2" v-for="(asset, index) in assets" :key="asset.$id">
          <router-link
            v-bind:to="/schule/ + schoolId + /bibliothek/ + asset.$id"
            class="nav-link"
          >{{ asset.name }}</router-link>
          <ul class="ml-5" v-if="asset.nodenames.length > 0">
            <li class="ma-2" v-for="(nodename, index2) in asset.nodenames" :key="nodename+index+index2">{{nodename}}</li>
          </ul>
        </li>
        <network
            class="network visContainer"
            :ref="`${result.$id}`"
            @select-node="selectNode(result.$id, index)"
            :nodes="result.network.nodes"
            :edges="result.network.edges"
            :options="result.network.options"
        />
      </ul>-->
    </div>
</template>
<script>
// import { fetchSchool, fetchAssets, duplicateGraph } from "../firebase/firebase";
import graphService from "../graphService/graphService.js";

export default {
  name: "library",
  props: {
    school: String
  },
  methods: {
    selectGraph(item) {
      this.$store.commit("global/setSelectedGraph", item.id);
    },
    selectUserGraph() {
      this.$store.commit("global/setSelectedGraph", this.userGraph.id);
    }
  },
  data() {
    return {
      name: "",
      schoolId: "e5abIXEqXZc3x5I0hYhd",
      assets: [],
      userGraph: null,
      currentSelectedNode: null
    };
  },
  async created() {
    this.$store.commit("global/setSchool", this.schoolId);
    // this.name = (await fetchSchool(this.schoolId).get()).data().name;
    // var result = await fetchAssets(this.schoolId).get();
    // this.assets = result.docs.map(doc => {
    //   const $data = doc.data();
    //   const $nodeNames = $data.nodes.map(node => {
    //     return node.label;
    //   });
    //   return {
    //     $id: doc.id,
    //     name: $data.name,
    //     nodenames: $nodeNames,
    //     nodes: $data.nodes,
    //     edges: $data.edges,
    //     options: {
    //       groups: {
    //         switch: {
    //           shape: "box",
    //           color: "#24d453" // green
    //         }
    //       },
    //       physics: {
    //         enabled: false
    //       },
    //       clickToUse: true
    //     }
    //   }
    // });
    const graphs = graphService.getAllGraphs();
    this.userGraph = graphs.splice(0, 1)[0];
    console.log("TEST", this.userGraph);
    this.assets = graphs.map($graph => {
      let asset = {
        ...$graph
      };
      asset.steps = $graph.nodes.length;
      return asset;
    });
  },
  destroyed() {}
};
</script>
<style scoped>
.visContainer {
  height: 100%;
  width: 100%;
  height: 150px;
}

.nav-link {
  font-size: 20px;
  margin-bottom: 16px;
}
.ma-2 {
  margin: 4px;
}
.ml-5 {
  margin-left: 32px;
}

.searchBox {
  width: 100%;
  font-size: 1.25em;
  border: 0;
  outline: 0;
  border-radius: 2px;
  height: 2rem;
  padding: 0 0.714em;
}

.tableWrapper {
  width: 100%;
}

.searchTable {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

h3 {
  margin-left: 5px;
  font-size: 1.25em;
}

table {
  width: 100%;
  font-size: 1.25em;
  background-color: rgba(199, 199, 199, 0.1);
}

tr {
  height: 30px;
}

td {
  font-size: 1.25em;
  padding: 10px;
  width: 50%;
  display: table-cell;
  vertical-align: middle;
}

tr:hover {
  background-color: rgba(199, 199, 199, 0.3);
}

.addButton {
  cursor: pointer;
}
.mr-2 {
  margin-right: 4px;
}

.mv-2 {
  margin-bottom: 4px;
  margin-top: 4px;
}

.flex-wrapper {
  display: flex;
}
.flex {
  flex: 1;
  flex-direction: row;
}
.flex-wrapper-vertical {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-end
}
.right-aligned{
  justify-content: flex-end
}
</style>